"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPionexLinkAppParams = exports.getPionexLinkWebUrl = exports.parsePionexLink = exports.buildPionexLink = void 0;
const dataRetrive_1 = require("../dataRetrive");
const network_1 = require("../network");
const rxjs_1 = require("rxjs");
const TAG = "PionexLink";
/**
 * 构建 pionex link
 * @param buildLinkParams
 */
function buildPionexLink(buildLinkParams) {
    const { origin = "https://link.pionex.com" } = buildLinkParams, rest = __rest(buildLinkParams, ["origin"]);
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(rest)) {
        if (!value) {
            continue;
        }
        if (key === "params") {
            searchParams.set(key, JSON.stringify(value));
        }
        else {
            searchParams.set(key, value);
        }
    }
    return `${origin}/?${searchParams.toString()}`;
}
exports.buildPionexLink = buildPionexLink;
/**
 * 解析 pionex link
 * @param link
 */
function parsePionexLink(link) {
    return __awaiter(this, void 0, void 0, function* () {
        (0, dataRetrive_1.getTradeDependencyInstance)().getLogger().i(TAG, "parse link", link);
        if (!link) {
            return null;
        }
        try {
            const { pathname, search, searchParams } = new URL(link);
            if (pathname.startsWith("/sl/")) {
                // 短连接
                return (0, rxjs_1.firstValueFrom)(network_1.Network.get({ url: `${(0, dataRetrive_1.getTradeDependencyInstance)().getRunTimeHost().linkApiHost}${pathname}${search}` }))
                    .catch((error) => {
                    (0, dataRetrive_1.getTradeDependencyInstance)().getLogger().e(TAG, "parse short link error", error);
                    return null;
                });
            }
            const pionexLink = { link, page: "", url: "" };
            searchParams.forEach((value, key, parent) => {
                if (key === "params") {
                    try {
                        pionexLink.params = JSON.parse(value);
                    }
                    catch (error) {
                        (0, dataRetrive_1.getTradeDependencyInstance)().getLogger().e(TAG, "parse params error", error);
                    }
                }
                else {
                    pionexLink[key] = value;
                }
            });
            if (!pionexLink.url || (!pionexLink.webOnly && !pionexLink.page)) {
                return null;
            }
            return pionexLink;
        }
        catch (error) {
            (0, dataRetrive_1.getTradeDependencyInstance)().getLogger().e(TAG, "parse link error", error);
        }
        return null;
    });
}
exports.parsePionexLink = parsePionexLink;
/**
 * 获取跳转到web的url
 * @param pionexLink
 * @param isMobile 是否是在移动端打开
 */
function getPionexLinkWebUrl(pionexLink, isMobile) {
    if (!pionexLink) {
        return "";
    }
    const { link, url, mUrl, page, params, minVersion, title, desc, preview, webOnly, noOG } = pionexLink, rest = __rest(pionexLink, ["link", "url", "mUrl", "page", "params", "minVersion", "title", "desc", "preview", "webOnly", "noOG"]);
    try {
        const redirectUrl = new URL(isMobile && mUrl ? mUrl : url);
        let urlChanged = false;
        for (const [key, value] of Object.entries(rest)) {
            if (!redirectUrl.searchParams.get(key)) {
                urlChanged = true;
                redirectUrl.searchParams.set(key, value);
            }
        }
        if (urlChanged) {
            return redirectUrl.toString();
        }
    }
    catch (error) {
        (0, dataRetrive_1.getTradeDependencyInstance)().getLogger().e(TAG, "get redirect url error", error);
    }
    return url;
}
exports.getPionexLinkWebUrl = getPionexLinkWebUrl;
/**
 * 获取App跳转页面所需的参数
 * @param pionexLink
 */
function getPionexLinkAppParams(pionexLink) {
    if (!pionexLink) {
        return {};
    }
    const { link, page, params, minVersion, title, desc, preview, webOnly, noOG, mUrl } = pionexLink, rest = __rest(pionexLink, ["link", "page", "params", "minVersion", "title", "desc", "preview", "webOnly", "noOG", "mUrl"]);
    const pageParams = Object.assign({}, (params || {}));
    for (const [key, value] of Object.entries(rest)) {
        if (!pageParams[key]) {
            pageParams[key] = value;
        }
    }
    return pageParams;
}
exports.getPionexLinkAppParams = getPionexLinkAppParams;
